// index.tsx
import React from "react";
import ReactDOM from "react-dom/client";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./utils/auth-config";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { Provider } from "react-redux";
import { persistor, store } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import App from "./app";


// Initialize Fluent UI icons once
initializeIcons();

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

/**
 * RootProviders component wraps App with all global providers:
 * - Redux store
 * - PersistGate (redux-persist)
 * - MSAL authentication
 */
const RootProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <MsalProvider instance={msalInstance}>{children}</MsalProvider>
    </PersistGate>
  </Provider>
);

// Initialize MSAL and render the app
msalInstance
  .initialize()
  .then(() => {
    const root = ReactDOM.createRoot(document.getElementById("root")!);
    root.render(
      <React.StrictMode>
        <RootProviders>
          <App />
        </RootProviders>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error("MSAL initialization failed:", error);
    // Optional: render fallback UI
  });
